// src/pages/CartPage.js
import React, { useContext, useState, useEffect } from "react";
import { CartContext } from "../utils/cartContext";
import "../styles/cart.css";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa"; // 🗑️ Import bin icon
import { auth } from "../utils/firebaseconfig";
import { onAuthStateChanged } from "firebase/auth";
import { checkVerification } from "../utils/verificationCheck";

function CartPage() {
  const { cart, removeFromCart, updateQuantity, clearCart } = useContext(CartContext);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setIsVerified(currentUser?.emailVerified || false);
    });
    
    return () => unsubscribe();
  }, []);

  // Calculate total price
  const totalPrice = cart.reduce((acc, item) => acc + item.price * item.quantity, 0);
  
  // Handle checkout with verification
  const handleCheckout = () => {
    if (!user) {
      alert("Please log in to checkout.");
      navigate("/login");
      return;
    }
    
    if (!isVerified) {
      if (!checkVerification(navigate)) {
        return;
      }
    }
    
    navigate("/checkout");
  };

  return (
    <div className="cart-container">
      <h2>Shopping Cart</h2>
      {cart.length === 0 ? (
        <p>Your cart is empty.</p>
      ) : (
        <>
          {/* 🔹 Cart Grid */}
          <div className="cart-grid">
            {cart.map((item) => (
              <div key={item.id} className="cart-item">
                <img src={item.image || "https://placehold.co/300"} alt={item.title} className="cart-item__image" />
                <div className="cart-item__details">
                  <h3>{item.title}</h3>
                  <p>Price: AED {Number(item.price).toFixed(2)}</p>
                  <div className="cart-item__quantity">
                    <button onClick={() => updateQuantity(item.id, Math.max(1, item.quantity - 1))}>-</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                  </div>
                </div>
                <button className="remove-btn" onClick={() => removeFromCart(item.id)}>
                  <FaTrash /> {/* 🗑️ Bin icon */}
                </button>
              </div>
            ))}
          </div>

          {/* 🔹 Cart Summary */}
          <div className="cart-summary">
            <h3>Total: AED {totalPrice.toFixed(2)}</h3>
            <button 
              className={`checkout-btn ${user && !isVerified ? 'disabled-checkout' : ''}`} 
              onClick={handleCheckout}
              disabled={user && !isVerified}
            >
              {user && !isVerified ? "Verify Email to Checkout" : "Proceed to Checkout"}
            </button>
            <button className="clear-cart-btn" onClick={clearCart}>Clear Cart</button>
          </div>
          
          {user && !isVerified && (
            <div className="verification-warning cart-verification">
              <p>Email verification required to complete checkout</p>
              <button 
                onClick={() => checkVerification(navigate)}
                className="verify-email-button"
              >
                Verify Email
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default CartPage;
